export enum INTEGRATION_TYPES {
  AEM = 'AEM',
  STANDALONE = 'STANDALONE',
}
